import { PurchaseOrderStatus } from './purchase-order-status.enum';

export const PURCHASE_ORDER_STATUS_LABELS: Record<PurchaseOrderStatus, string> = {
    [PurchaseOrderStatus.PendingSupApproval]: 'Pending Supervisor Approval',
    [PurchaseOrderStatus.PendingReceipt]: 'Pending Receipt',
    [PurchaseOrderStatus.RejectedBySup]: 'Rejected By Supervisor',
    [PurchaseOrderStatus.PartiallyReceived]: 'Partially Received',
    [PurchaseOrderStatus.PendingBillPartReceived]: 'Pending Billing/Partially Received',
    [PurchaseOrderStatus.PendingBill]: 'Pending Billing',
    [PurchaseOrderStatus.FullyBilled]: 'Fully Billed',
    [PurchaseOrderStatus.Closed]: 'Closed',
};
